import { FontAwesomeIcon } from '@fortawesome/react-fontawesome';
import { faTimes } from '@fortawesome/pro-solid-svg-icons/faTimes';
import PropTypes from 'prop-types';
import { FormattedMessage } from 'react-intl';

import { BannerStatus } from 'ui-components/components/banner-message/banner-enums';
import { BannerMessageV2 } from 'ui-components/components/banner-message/banner-message-v2';

import style from './style.module.less';
import { MessageDescriptorPropType } from '../../../../../prop-types/intl';
import { useShipFromPageErrorContext } from '../../contexts/ship-from-page-error-context-provider';

const ShipFromPageError = ({ error }) => {
  const { removeError } = useShipFromPageErrorContext();
  return (
    <BannerMessageV2
      content={
        <div className={style['content-container']}>
          <div>
            <FormattedMessage {...error.messageDescriptor} values={error.values} />
          </div>
          <div className={style['close-button']} onClick={() => removeError(error.contextErrorId)}>
            <FontAwesomeIcon className={style.icon} icon={faTimes} />
          </div>
        </div>
      }
      status={BannerStatus.Error}
    />
  );
};

ShipFromPageError.propTypes = {
  error: PropTypes.shape({
    messageDescriptor: MessageDescriptorPropType,
    values: PropTypes.object,
    contextErrorId: PropTypes.string,
  }).isRequired,
};

export default ShipFromPageError;
